import React, { FC, useEffect, useRef } from "react"

import { isClientSide } from "@utils"

import {
  PostCategoryFragmentFragment,
  PostCategoryFullDataFragmentFragment,
  PostSubCategoryFragmentFragment,
} from "@graphqlTypes"

import Hero from "@components/Hero/Hero"
// import ImageAboveFold from "@components/ImageAboveFold/ImageAboveFold"

import PostsNav from "../PostsNav/PostsNav"

import {
  PostsHeroContentDIV,
  PostsHeroDIV,
  PostsHeroTopicsLINK,
  PostsHeroTopicsLinksDIV,
  PostsHeroTopicsNAV,
  PostsHeroTopicsScrollerDIV,
} from "./PostsHero.styles"

type PostHeroProps = {
  allCategories?: PostCategoryFragmentFragment[]
  categoryPermalink: PostCategoryFullDataFragmentFragment["permalink"]
  categorySlug: PostCategoryFullDataFragmentFragment["slug"]
  currentTopicSlug?: string
  description?: PostCategoryFullDataFragmentFragment["seoDescription"]
  isLandingPage?: boolean
  title: PostCategoryFullDataFragmentFragment["title"]
  topics?: (PostSubCategoryFragmentFragment | null)[] | null
}

const PostsHero: FC<PostHeroProps> = ({
  allCategories,
  categoryPermalink,
  categorySlug,
  currentTopicSlug,
  description,
  isLandingPage,
  title,
  topics,
}) => {
  const topicsScrollElRef = useRef<HTMLDivElement>(null)
  const isArchive = !isLandingPage && categorySlug === "all"

  useEffect(() => {
    if (!isClientSide() || !topicsScrollElRef.current || !currentTopicSlug)
      return

    const currentNavEl = topicsScrollElRef.current.querySelector(
      `.${currentTopicSlug}`
    )
    if (!currentNavEl) return

    const positionXToScroll =
      currentNavEl.getBoundingClientRect().x - 15 - window.innerWidth * 0.025

    topicsScrollElRef.current.scroll({ left: positionXToScroll })
  }, [currentTopicSlug])

  return (
    <Hero style={{ overflow: "visible" }}>
      <PostsHeroDIV
        className={`${isLandingPage ? "is-landing-page" : ""} ${isArchive ? "is-archive" : ""
          }`}
      >
        <PostsNav currentCategorySlug={categorySlug} />
        {!isLandingPage && (
          <PostsHeroContentDIV>
            <div className="container">
              {/* Don't show the title on the archive page */}
              {!isArchive && (
                <h1>{title}</h1>
              )}
              {description && (
                <p className="type--text-L posts-hero-description">
                  {description}
                </p>
              )}
              {topics &&
                topics.length > 0 && (
                  <PostsHeroTopicsNAV>
                    <PostsHeroTopicsScrollerDIV ref={topicsScrollElRef}>
                      <PostsHeroTopicsLinksDIV>
                        <PostsHeroTopicsLINK
                          className={`font--text-XS ${!currentTopicSlug ? "is-active" : ""
                            }`}
                          to={categoryPermalink || "/"}
                        >
                          All
                        </PostsHeroTopicsLINK>
                        {topics.map((topic) =>
                          topic ? (
                            <PostsHeroTopicsLINK
                              key={topic.slug}
                              className={`font--text-XS ${topic.slug}${currentTopicSlug === topic.slug
                                ? " is-active"
                                : ""
                                }`}
                              to={topic.permalink || "/"}
                            >
                              {topic.title}
                            </PostsHeroTopicsLINK>
                          ) : null
                        )}
                      </PostsHeroTopicsLinksDIV>
                    </PostsHeroTopicsScrollerDIV>
                  </PostsHeroTopicsNAV>
                )}
            </div>
          </PostsHeroContentDIV>
        )}
      </PostsHeroDIV>
    </Hero>
  )
}

export default PostsHero
